import type { Report } from '#lib/types';
import { i18n, t } from '#lib/i18n/state.svelte';
import { issueTextEn } from '#lib/i18n/issues';
import { severityLabel } from '#lib/ui/labels';

function dateOf(report: Report): string {
	try {
		return new Date(report.generatedAt).toISOString().slice(0, 10);
	} catch {
		return '';
	}
}

function issueLine(issue: Report['issues'][number]): string {
	const en = i18n.lang === 'en' ? issueTextEn(issue) : null;
	const title = en ? en.title : issue.title;
	const detail = en ? en.detail : issue.detail;
	const at =
		issue.location.page !== undefined
			? ` (${t('common.page', { n: issue.location.page })})`
			: issue.location.sourceLine !== undefined
				? ` (${t('common.line', { n: issue.location.sourceLine })})`
				: '';
	return `- [${issue.code}] ${title} — ${detail}${at}`;
}

/** Markdown raporu (kopyalanabilir, LaTeX/Word notlarına yapıştırılabilir). */
export function toMarkdown(report: Report): string {
	const issues = report.issues.filter((i) => i.severity !== 'ok');
	const lines: string[] = [
		`# ${t('export.mdTitle')}: ${report.document.fileName}`,
		'',
		`**${t('export.mdScore')}: ${report.scores.overall}/${report.scores.grade}** | ${t('export.mdDate')}: ${dateOf(report)}`,
		'',
		`## ${t('export.mdIssues')} (${issues.length})`,
		''
	];

	for (const severity of ['critical', 'warning', 'info'] as const) {
		const group = issues.filter((i) => i.severity === severity);
		if (group.length === 0) continue;
		lines.push(`### ${severityLabel(severity)} (${group.length})`, '');
		for (const issue of group) lines.push(issueLine(issue));
		lines.push('');
	}

	if (issues.length === 0) lines.push(t('export.mdEmpty'), '');
	lines.push(`_${t('print.footer')}_`, '');
	return lines.join('\n');
}
